
import "/app/apps/cuba/src/components/right-content/index.less?modules";
export default {"account": `account-Wh_rOuFE`,"search": `search-U5-i4nwx`,"avatar": `avatar-3J-QMhCY`,"menu": `menu-tS-VSdZy`,"right": `right-aaRKhBhH`,"action": `action-OjgoMwjS`,"dark": `dark-hiRs_mQG`,"dropDown": `dropDown-N1HoAGRd`}
